/**
 * The picker's own narrowing of the rows it holds: every typed word must
 * appear somewhere in the row (name, secondary line or meta), in any order, as
 * the server's record search matches. "abc supply toledo" keeps ABC SUPPLY
 * with Toledo in its address line. Kept out of the component file so it is
 * unit-testable and react-refresh stays happy.
 */
export function filterByEveryWord<
  T extends { name: string; secondary?: string; meta?: string },
>(options: T[], filter: string): T[] {
  const words = [...new Set(filter.toLowerCase().split(/[\s,]+/).filter(Boolean))]
  if (words.length === 0) return options
  return options.filter((option) => {
    const text = [option.name, option.secondary, option.meta]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
    return words.every((word) => text.includes(word))
  })
}
